// HomeCard.js for the mobile navigator
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faClock, faStar, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import './HomeCard.css'; 

// Define the HomeCard component
const HomeCard = () => {
  return (
    <div className="homeCard">
      <div className="nav-container">
        {/* Home Link */}
        <NavLink to="/" className="nav-link" activeClassName="current">
          <FontAwesomeIcon icon={faHome} className="nav-icon" />
          <div className="nav-text">Home</div>
        </NavLink>
        
        {/* Recent Link */}
        <NavLink to="/recent" className="nav-link" activeClassName="current">
          <FontAwesomeIcon icon={faClock} className="nav-icon" />
          <div className="nav-text">Recent</div>
        </NavLink>
        
        {/* Popular Link */}
        <NavLink to="/popular" className="nav-link" activeClassName="current">
          <FontAwesomeIcon icon={faStar} className="nav-icon" />
          <div className="nav-text">Popular</div>
        </NavLink>
        
        {/* Documentation Link */}
        <NavLink to="https://github.com/Gozkybrain/v2-watcheMe" className="nav-link" activeClassName="current" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFileAlt} className="nav-icon" />
          <div className="nav-text">Documentation</div>
        </NavLink>
      </div>
    </div>
  );
};

export default HomeCard;
